import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-favourite-outline-icon',
  templateUrl: './bmcore-favourite-outline-icon.component.html',
  styleUrls: ['./bmcore-favourite-outline-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreFavouriteOutlineIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
